export const stopVideo = function () {
  const iframe = document.querySelector("iframe");
  if (iframe) {
    const message = JSON.stringify({ event: "command", func: "pauseVideo" });
    iframe.contentWindow.postMessage(message, "*");
  }
};
